import React from "react";
import { JwtUser } from "../entities/auth/JwtUser";

export const UserContext = React.createContext<[JwtUser | undefined, (jwt: string) => void]>([undefined, () => {}]);

export function useUser() {
	return React.useContext(UserContext);
}
